export const ENGLISH_TRANSLATIONS = {
	menu: {
		return: 'Return to menu',
		logOut: 'Log Out'
	}
};
